/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { MatTableDataSource } from '@angular/material/table';

export class FilterableDataSource<T> extends MatTableDataSource<T> {
  constructor(data?: T[]) {
    super(data);
    this.filterPredicate = this.predicate;
  }

  setFilter(filter: Partial<T>): void {
    this.filter = JSON.stringify(filter);
  }

  protected predicate(value: T, filter: string): boolean {
    let isMatch = true;
    const filterValues: Map<string, string> = JSON.parse(filter);

    for (const [propertyName, filterValue] of Object.entries(filterValues)) {
      isMatch = isMatch && value[propertyName].toLowerCase().includes(filterValue.toLowerCase());
    }

    return isMatch;
  }
}
